import React from "react";

import { CloseRounded, SendRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";
import { httpsCallable } from "firebase/functions";

import useFirebase from "../../config/context/firebaseContext";
import useModal from "../../config/context/modalContext";
import { Dev } from "../../config/util/consoleUtil";

import SimpleBase64 from "../InputImage/SimpleBase64";
import TextMain from "../InputMain/TextMain";
import { WideDialog } from "../MainModalSimple/styles";
import MainSolidButton from "../MainSolidButton";
import MainText from "../MainText";
import { ModalTransition } from "../ModalTransition";
import PageHeader from "../PageHeader";

import { ModalBaseType } from "../../types/common";
import { UserUploadedFileType } from "../../types/database";

export default function ModalSpottCreate({ onClose }: ModalBaseType) {
  const [open, setOpen] = React.useState(true);

  const { pushAlert } = useModal();

  const { functions } = useFirebase();

  const [postField, setPostField] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const [uploadedFiles, setUploadedFiles] = React.useState<UserUploadedFileType[]>([]);

  const handleSend = async () => {
    try {
      setLoading(true);
      const createPost = httpsCallable(functions, "createPost");

      const payload = {
        text: postField,
        file: uploadedFiles?.[0],
      };

      const response = await createPost(payload);

      pushAlert({
        type: "success",
        message: "Seu spott foi enviado para avaliação",
      });

      handleClose();
    } catch (error) {
      console.log(...new Dev("handleSend", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao criar spott",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={"Enviar Spott"}
          rightIcon={<CloseRounded />}
          onRightAction={handleClose}
        />

        <Box>
          <Box mt={4}>
            <TextMain
              lines={4}
              autoCapitalize="sentences"
              borderColor={"regular"}
              textColor={"regular"}
              inputType="email"
              inputMode="email"
              name="Escreva aqui a sua postagem"
              onChange={setPostField}
              value={postField}
            />
          </Box>

          <Box>
            <SimpleBase64
              fileList={uploadedFiles}
              setFileList={setUploadedFiles}
              imageHeight={120}
              isImage
            />
          </Box>

          <Box my={3}>
            <MainSolidButton
              loading={loading}
              text="Enviar"
              icon={<SendRounded />}
              onClick={handleSend}
            />
          </Box>

          <MainText size="tiny" color="regular">
            O seu causo ainda passa por uma avaliação pra filtrar conteúdo indesejado. Mas a
            aprovação é bem rápida.
          </MainText>
          <MainText size="tiny" color="regular">
            E todas as postagens são anônimas. Não precisa se preocupar...
          </MainText>
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
